module.exports = __webpack_public_path__ + "img/downAppCode2.dc6cbce0.png";